import { getLinearSettings } from "../../../../viewer/chart/helper.ts";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function valueAxisTitle(settings: ChartStyleSettings, name: string) {
  return getLinearSettings(settings)?.valueAxis?.find((va) => va.name === name)?.title || "";
}
